module.exports = __webpack_public_path__ + "img/emoji_165.95371a4d.png";